<template>
  <b-modal
    dialog-class="add-installation-modal"
    header-class="add-installation-header"
    body-class="add-installation-body"
    footer-class="add-installation-footer"
    :id="id"
    centered
    scrollable
    :hide-footer="step === 2"
    @hide="resetData()"
    @show="updateData()"
  >
    <template #modal-header="{ close }">
      <subtitle>{{ title }}</subtitle>
      <button class="news-close-button" @click="close()" />
    </template>

    <div v-if="step === 1" class="add-installation-content">
      <horizontal-menu
        :menuItems="menuItems"
        :activeMenuItem="activeMenuItem"
        @onMenuItemChange="handleMenuItemChange"
      />
      <div class="add-installation-grid">
        <div
          @click="handleInstallationClick(option.value)"
          :key="option.value"
          v-for="option in options"
          class="add-installation-card"
        >
          <img :src="getInstallationImage(option.value)" alt="icon" />
          <p>{{ option.text }}</p>
        </div>
      </div>
    </div>

    <div v-if="step === 2" class="add-installation-form">
      <button class="back-button" @click="step = 1">
        <img class="back-button-icon" src="../../files/arrow-left-primary.svg" alt="arrow left" /> Назад
      </button>

      <reservoir-atm-pressure
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 1 || type == 2 || type == 3 || type == 4 || type == 5"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />
      <pump-liquid
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 31"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />
      <lpg-compressor
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 32"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <gas-compressor
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 33"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <chemical-reactor
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 51"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <pressure-apparatus
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 11"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <wall-pad
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 17 || type == 19"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <ball-tank
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 14 || type == 15"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <lpg-pressure-apparatus
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 12 || type == 6 || type == 7"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <gas-pressure-apparatus
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 13"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <gas-ball-tank
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 16"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <fuel-dispenser
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 21"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <lpg-fuel-dispenser
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 22"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <gas-candle
        @create="create($event)"
        :saving="saving"
        :substances="substances"
        :installation.sync="installation"
        :substance="cur_substance"
        v-if="type == 34"
        :proj_id="projId"
        :type="Number(type)"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />
    </div>

    <template #modal-footer="{ cancel }">
      <main-button
        class="add-installation-footer-button"
        color="link"
        @click="
          resetData();
          cancel();
        "
      >
        Отмена</main-button
      >
    </template>
  </b-modal>
</template>

<script>
import Subtitle from "../ui/Subtitle.vue";
import MainButton from "../ui/MainButton.vue";
import HorizontalMenu from "../HorizontalMenu.vue";
import ReservoirAtmPressure from "../InstallationForms/ReservoirAtmPressure.vue";

import { getImage } from "../../utils/utils";
import PumpLiquid from "../InstallationForms/PumpLiquid.vue";
import LpgCompressor from "../InstallationForms/LpgCompressor.vue";
import GasCompressor from "../InstallationForms/gasCompressor.vue";
import ChemicalReactor from "../InstallationForms/ChemicalReactor.vue";
import PressureApparatus from "../InstallationForms/PressureApparatus.vue";
import WallPad from "../InstallationForms/WallPad.vue";
import BallTank from "../InstallationForms/BallTank.vue";
import LpgPressureApparatus from "../InstallationForms/LpgPressureApparatus.vue";
import GasPressureApparatus from "../InstallationForms/GasPressureApparatus.vue";
import GasBallTank from "../InstallationForms/GasBallTank.vue";
import FuelDispenser from "../InstallationForms/FuelDispenser.vue";
import LpgFuelDispenser from "../InstallationForms/LpgFuelDispenser.vue";
import GasCandle from "../InstallationForms/GasCandle.vue";

export default {
  props: {
    title: String,
    id: {
      type: [String, Number],
      require: true,
    },
    projId: [Number, String],
    installation: Object,
    installation_index: Number,
    showErrors: Function,
  },
  components: {
    Subtitle,
    MainButton,
    HorizontalMenu,
    ReservoirAtmPressure,
    PumpLiquid,
    LpgCompressor,
    GasCompressor,
    ChemicalReactor,
    PressureApparatus,
    WallPad,
    BallTank,
    LpgPressureApparatus,
    GasPressureApparatus,
    GasBallTank,
    FuelDispenser,
    LpgFuelDispenser,
    GasCandle,
  },

  data() {
    return {
      menuItems: [
        { text: "Жидкость", menuItem: "liquid" },
        { text: "СУГ, СПГ", menuItem: "sug" },
        { text: "Газ", menuItem: "gas" },
      ],
      activeMenuItem: "liquid",
      saving: false,
      step: 1,
      substances: [],
      cur_substance: {},
      type: null,
      validator: {},
    };
  },

  methods: {
    handleInstallationClick(type) {
      this.step = 2;
      this.type = type;
      this.validator = {};
    },

    handleMenuItemChange(item) {
      this.activeMenuItem = item;
    },

    getInstallationImage(type) {
      return getImage(type);
    },

    create(model) {
      this.$emit("clearCalculations");
      if (!model.id) {
        this.$set(this, "saving", true);

        this.$http
          .post("risk/objects/create?proj_id=" + this.projId, {
            ...model,
            substance: model.substance ? model.substance.code : null,
            extinguish_system: model.extinguish_system ? model.extinguish_system.code : undefined,
            alarm_system: model.alarm_system ? model.alarm_system.code : undefined,
            underground: model.underground ? Number(model.underground) : 0,
          })
          .then((response) => {
            this.$set(this, "saving", false);
            this.$emit("newObject", response.data);
          })
          .catch((e) => {
            this.$set(this, "saving", false);
            if (e.response.status === 500) {
              this.$set(this, "validator", e.response.data);
              alert(`На сервере произошла ошибка: ${e.response.data}`);
              return;
            }
            if (e.response.data) {
              this.$set(this, "validator", {});
              this.$set(this, "validator", e.response.data);
            }
          });
      } else {
        this.$set(this, "saving", true);

        this.$http
          .post("risk/objects/update?proj_id=" + this.projId + "&id=" + model.id, {
            ...model,
            substance: model.substance ? model.substance.code : null,
            extinguish_system: model.extinguish_system ? model.extinguish_system.code : undefined,
            alarm_system: model.alarm_system ? model.alarm_system.code : undefined,
            underground: model.underground ? Number(model.underground) : 0,
          })
          .then((response) => {
            this.$set(this, "saving", false);
            Object.assign(this.installation, response.data);
            if (response.data.errors) {
              this.showErrors(response.data.errors);
            }
            this.$bvModal.hide("addInstallation");
          })
          .catch((e) => {
            this.$set(this, "saving", false);
            if (e.response.data) {
              this.$set(this, "validator", e.response.data);
            }
          });
      }
    },

    resetData() {
      this.step = 1;
      this.substances = [];
      this.cur_substance = {};
      this.type = null;
      this.validator = {};
    },

    loadSubstances(types) {
      this.$http.get("risk/substance/substances?types=" + types).then((response) => {
        this.substances = response.data;
        this.getSubstance();
      });
    },

    getSubstance() {
      if (this.installation.substance && typeof this.installation.substance !== "object") {
        for (let i in this.substances) {
          const data = this.substances[i].subs.find((cur) => cur.id == this.installation.substance);
          if (data) {
            this.cur_substance = data;
          }
        }
      }
    },
    updateData() {
      this.type = this.installation.obj_type;
      if (this.installation.id) {
        this.step = 2;
      }
    },
  },

  watch: {
    installation() {
      this.type = this.installation.obj_type;
      if (this.installation.id) {
        this.step = 2;
      } else {
        this.step = 1;
      }
    },
  },

  computed: {
    options() {
      switch (this.activeMenuItem) {
        case "liquid":
          return [
            {
              value: 1,
              text: "Вертикальный резервуар для хранения ЛВЖ и ГЖ при давлении, близком к атмосферному с плавающей крышей",
            },
            {
              value: 2,
              text: "Вертикальный резервуар для хранения ЛВЖ и ГЖ при давлении, близком к атмосферному со стационарной крышей",
            },
            {
              value: 3,
              text: "Горизонтальный резервуар для хранения ЛВЖ и ГЖ при давлении, близком к атмосферному",
            },
            {
              value: 4,
              text: "Автоцистерна содержащая ЛВЖ и ГЖ при давлении, близком к атмосферному",
            },
            {
              value: 5,
              text: "Железнодорожная цистерна содержащая ЛВЖ и ГЖ при давлении, близком к атмосферному",
            },
            {
              value: 11,
              text: "Резервуар, емкость, сосуд или аппарат под давлением",
            },
            { value: 17, text: "Устье скважины" },
            { value: 14, text: "Шаровый резервуар (ЛВЖ и ГЖ)" },
            { value: 21, text: "ТРК (ЛВЖ и ГЖ)" },
            {
              value: 31,
              text: "Насос (центробежный) для перекачки ЛВЖ и ГЖ",
            },
            {
              value: 51,
              text: "Химический реактор (ЛВЖ или ГЖ)",
            },
          ];
        case "sug":
          return [
            {
              value: 12,
              text: "Резервуар, емкость, сосуд или аппарат под давлением (СУГ или СПГ)",
            },
            { value: 6, text: "Автоцистерна содержащая СУГ" },
            {
              value: 7,
              text: "Железнодорожная цистерна содержащая СУГ",
            },
            { value: 15, text: "Шаровый резервуар (СУГ или СПГ)" },
            { value: 32, text: "Компрессор" },
            { value: 22, text: "ГРК (СУГ)" },
          ];

        case "gas":
          return [
            {
              value: 13,
              text: "Резервуар, емкость, сосуд или аппарат под давлением (Газ)",
            },
            { value: 16, text: "Шаровый резервуар (Газ)" },
            { value: 19, text: "Устье скважины" },
            { value: 33, text: "Компрессор" },
            { value: 34, text: "Газовая свеча" },
          ];
      }
      return [];
    },
  },
};
</script>

<style>
.add-installation-header {
  padding: 24px 24px 0;
  border: none;
}

.add-installation-body {
  padding: 0;
}

.add-installation-footer {
  margin-top: 32px;
  padding: 16px 24px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--background-color);
}

.add-installation-grid {
  padding: 32px 0 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.add-installation-card {
  min-width: 240px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  background: var(--white-color);
  transition: border 0.15s ease-out;
  cursor: pointer;
}

.add-installation-card:hover {
  border: 1px solid var(--secondary-color);
}

.add-installation-modal {
  max-width: none;
  width: 55%;
  min-width: 800px;
}

.back-button {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  border: none;
  padding: 0;
  background: transparent;
  color: var(--primary-color);
  opacity: 1;
  transition: opacity 0.15s ease-out;
  margin-bottom: 26px;
  margin-left: 24px;
}

.add-installation-modal .back-button {
  margin-top: 42px;
}

.back-button:hover {
  opacity: 0.75;
}

.back-button-icon {
  margin-right: 8px;
}
.add-installation-content {
  padding: 0 24px;
}
</style>
